import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiPlus } = FiIcons;

const questions = [
  ['How long does it take?', 'About 10 minutes.'],
  ['Do I need to install anything?', 'No, it runs in your browser. You’ll need to allow your microphone.'],
  ['Is my session recorded?', 'Replace with your program’s real answer before launch.'],
  ['Who sees my results?', 'Replace with your program’s real answer before launch.']
];

function FAQ() {
  return (
    <section className="faq-section section-wrap">
      <div className="section-heading">
        <span className="eyebrow">Good to know</span>
        <h2>Frequently asked questions</h2>
      </div>
      <div className="faq-list">
        {questions.map(([question, answer]) => (
          <details className="faq-item" key={question}>
            <summary>
              <span>{question}</span>
              <SafeIcon icon={FiPlus} className="faq-plus" aria-hidden="true" />
            </summary>
            <p>{answer}</p>
          </details>
        ))}
      </div>
    </section>
  );
}

export default FAQ;
